// extracted by mini-css-extract-plugin
module.exports = {"audioPlayer":"AudioPlayer_audioPlayer__1crxb","title":"AudioPlayer_title__Y09ON","rangeOuter":"AudioPlayer_rangeOuter__34xbF","range":"AudioPlayer_range__QPV0j"};